export default __webpack_public_path__ + "static/media/Blomberg.f8ab340d.svg";